<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="wrapper">
      <div class="d-flex flex-row-reverse mb-3">
        <language-select
          v-model="language"
          @change="handleChangeLanguage"
        ></language-select>
      </div>
      <service-category-editor
        v-model="form"
        :iconUrl="iconUrl"
        :disabled="$isCallCenter"
      ></service-category-editor>
      <div class="text-right" v-if="!$isCallCenter">
        <sc-button
          class="btn-remove"
          variant="danger"
          @click="handleClickRemove"
          >ลบ</sc-button
        >
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import LanguageSelect from "@/lib/components/LanguageSelect";
import ServiceCategoryEditor from "../components/ServiceCategoryEditor";
import { baanRueJaiClient } from "@/dependencies";
import { uploadPublicImage } from "@/god";
import { localization } from "@/lib/mapper";
import { isEmpty } from "ramda";

export default {
  components: {
    PageWrapper,
    ScButton,
    ServiceCategoryEditor,
    LanguageSelect
  },
  data() {
    const title = "รายละเอียดหมวดหมู่";
    const form = {
      name: "",
      services: [],
      iconFile: null
    };

    const services = [];
    const iconUrl = null;
    const category = null;

    return {
      title,
      form,
      iconUrl,
      category,
      services,
      language: localization.TH
    };
  },
  watch: {
    form(form, oldForm) {
      if (this.form.iconFile === oldForm.iconFile) {
        return;
      }

      this.iconUrl = URL.createObjectURL(this.form.iconFile);
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupData();
      this.setupForm();
    },
    setupData() {
      return Promise.all([this.setupCategory(), this.setupServices()]);
    },
    async setupCategory() {
      const category = await this.fetchData();

      this.category = category;
    },
    async setupServices() {
      const { count, services } = await this.fetchServices();

      this.services = services.map(service => {
        const {
          id,
          name,
          short_description: shortDescription,
          description,
          icon_url: iconUrl
        } = service;
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url
        };
        const route = { name: "ServiceDetailPage", params: { id } };

        return {
          id,
          iconUrl,
          name,
          shortDescription,
          description,
          provider,
          route
        };
      });
    },
    async setupForm() {
      this.form = {
        name: this.category.name,
        services: this.services,
        iconFile: null
      };

      this.iconUrl = this.category.icon;
    },
    async fetchData() {
      const { id } = this.$route.params;

      const response =
        this.language === localization.TH
          ? await baanRueJaiClient.admin.subscriptions.serviceCategories.get(
              id
            )
          : await baanRueJaiClient.admin.subscriptions.serviceCategories.getLocalization(
              id,
              this.language
            );

      return response.data.result;
    },
    async fetchServices() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.subscriptions.serviceCategories.getServices(
        id
      );

      return response.data.result;
    },
    async handleClickSave() {
      if (isEmpty(this.form.name.trim())) {
        alert("กรุณาใส่ชื่อหมวดหมู่บริการ");
        return;
      }
      if (!confirm("ยืนยันการบันทึก")) {
        return;
      }

      try {
        await this.update();
        this.$router.push({ name: "ServiceCategoryListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async handleClickRemove() {
      if (!confirm("ยืนยันการลบ")) {
        return;
      }

      try {
        await this.remove();
        alert("ลบเรียบร้อย");
        this.$router.push({ name: "ServiceCategoryListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    handleChangeLanguage() {
      this.setup();
    },
    async update() {
      const { id } = this.$route.params;
      const params = await this.getUpdateParams();

      const response =
        this.language === localization.TH
          ? await baanRueJaiClient.admin.subscriptions.serviceCategories.put(
              id,
              params
            )
          : await baanRueJaiClient.admin.subscriptions.serviceCategories.putLocalization(
              id,
              params,
              this.language
            );

      return response.data.result;
    },
    async getUpdateParams() {
      const { icon } = this.category;
      const { name, iconFile, services } = this.form;

      const serviceIds = services.map(service => service.id);
      const params = { name: name.trim(), serviceIds };

      if (iconFile) {
        params.icon = await uploadPublicImage(iconFile, name, "article");
      } else {
        params.icon = icon;
      }

      return params;
    },
    async remove() {
      const { id } = this.$route.params;

      await baanRueJaiClient.admin.subscriptions.serviceCategories.delete(id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}

.btn-remove {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/service-categories/pages/ServiceCategoryDetailPage.vue